import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrIgniteParticipateBoxLayoutParticipateItemCls: string;
			communityPlsrIgniteParticipateBoxLayoutStepWrapperCls: string;
			communityPlsrIgniteParticipateBoxLayoutRoboticsItemCls: string;
		}
	},

	slug: string
}

class Participate extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Ignite Participate Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrIgniteParticipateBoxLayoutParticipateItemCls || '', 'community_plsr_ignite_participate', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrIgniteParticipateBoxLayoutStepWrapperCls || '', 'community_plsr_ignite_participate', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrIgniteParticipateBoxLayoutRoboticsItemCls || '', 'community_plsr_ignite_participate', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Participate;